<app-microstrategy-cdn></app-microstrategy-cdn>
<router-outlet></router-outlet>
